module.exports = __webpack_public_path__ + "static/media/160307-MobileKickoff-Recap.017.9360030d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/160307-MobileKickoff-Recap/160307-MobileKickoff-Recap.017.png
// module id = 192
// module chunks = 0